import { makeStyles } from '@material-ui/core';

import withProps from 'hooks/withProps';
import InlinePrice from 'components/InlinePrice';
import Text from 'components/Text';

const Caption = withProps(Text, {
  color: 'colors.grey500',
  variant: 'caption3',
  view: 'desktop',
});
const Value = withProps(Text, {
  color: 'colors.grey900',
  variant: 'subtitle2-bold',
  view: 'desktop',
  lineHeight: 1,
});

const useStyles = makeStyles((theme) => ({
  cartMeta: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  cartMetaItem: {
    height: 40,
    minWidth: 80,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

const CartMeta = (props) => {
  const { cart } = props;
  const classes = useStyles();

  return (
    <div className={classes.cartMeta}>
      <div className={classes.cartMetaItem}>
        <Caption>Items</Caption>
        <Value>{cart?.cart_total_items || '-'}</Value>
      </div>

      <div className={classes.cartMetaItem}>
        <Caption>Price</Caption>

        <Value>
          {cart?.cart_total > 0 && (
            <InlinePrice value={cart?.cart_total} currency="usd" />
          )}
          {!cart?.cart_total && '-'}
        </Value>
      </div>
    </div>
  );
};

// TODO: Demo

export default CartMeta;
